import se from "../in-app-message-manager-factory.js";
import r from "../../managers/braze-instance.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import { showInAppMessage } from "./show-in-app-message.js";
import { subscribeToInAppMessage } from "../subscribe-to-in-app-message.js";
export function automaticallyShowInAppMessages() {
  if (!r.rr()) return;
  ss();
  const s = se.ea();
  if (null == s.Hi()) {
    const r = subscribeToInAppMessage((s) => showInAppMessage(s));
    s.Ji(r);
  }
  return s.Hi();
}
